export default __webpack_public_path__ + "static/media/DNo.17-1.5ca2bb04.jpg";